import React, {useState} from "react";
import Appointments from "./appointments";
import Invoices from "./invoices";
import Settings from "./settings";
import moment from "moment-timezone";
import {useHistory} from "react-router-dom";
import {HREF_PAGE_HELP} from "../../../models/constants";

export default function Navigation({points_of_sale}) {
  const [activeTab, setActiveTab] = useState("appointments");
  const history = useHistory();

  const params = Object.fromEntries(new URLSearchParams(window.location.search));

  const [form, setForm] = useState({
    q: params.q || "",
    start: params.start || moment().subtract(3, "month").format("YYYY-MM-01"),
    end: params.end || moment().format("YYYY-MM-DD"),
  });

  const [filters, setFilters] = useState({...form});

  const handleFormChange = (e) => {
    setForm({...form, [e.target.name]: e.target.value});
  };

  const onclickSeeTutorial = (e) => {
    e && e.preventDefault();
    history.push(HREF_PAGE_HELP + "?guide_category_id=8&article_id=10");
  };

  return (
    <>
      <form
        className="form-inline mb-3"
        onSubmit={(event) => {
          event.preventDefault();

          window.history.replaceState(null, "", `${window.location.pathname}?${new URLSearchParams(form)}`);

          setFilters({...form});
        }}
      >
        <input type="search" name="q" className="form-control mb-2 mr-sm-2" placeholder="Buscar documento o nombre..."
               value={form.q} onChange={handleFormChange} style={{width: '260px'}}/>
        <input type="date" name="start" className="form-control mb-2 mr-sm-2" value={form.start}
               onChange={handleFormChange} max={form.end}/>
        <input type="date" name="end" className="form-control mb-2 mr-sm-2" value={form.end} onChange={handleFormChange}
               min={form.start}/>
        <button type="submit" className="btn btn-primary mb-2 mr-sm-2">
          Filtrar
        </button>
      </form>
      {!points_of_sale?.length && (
        <div className="alert alert-outline-primary fade show" role="alert">
          <div className="alert-icon d-none d-lg-inline">
            <i className="flaticon-warning"></i>
          </div>
          <div className="alert-text text-center text-lg-left">Para emitir tus facturas, debes dar de alta un punto de
            venta compatible en ARCA.
          </div>
          <div className="d-inline-block m-2 float-none float-lg-right">
            <a className="btn btn-accent" href="#" onClick={onclickSeeTutorial}>
              Tutorial en 3 simples pasos.
            </a>
          </div>
        </div>
      )}
      <ul className="nav nav-tabs m-0">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "appointments" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("appointments");
            }}
          >
            Pendientes
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "invoices" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("invoices");
            }}
          >
            Facturados
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === "settings" ? "active" : ""}`}
            href="#"
            onClick={(event) => {
              event.preventDefault();
              setActiveTab("settings");
            }}
          >
            Configuración
          </a>
        </li>
      </ul>
      <div className="tab-content border border-top-0 bg-white overflow-auto">
        {activeTab === "appointments" && <Appointments filters={filters}/>}
        {activeTab === "invoices" && <Invoices filters={filters}/>}
        {activeTab === "settings" && <Settings/>}
      </div>
    </>
  );
}
